import { matchRoutes } from 'react-router-dom';
import { Location as HistoryLocation } from 'history';

import { PAGE_PATHS } from '@/shared/config/pages';

export function getCurrentPage(location: HistoryLocation) {
  return matchRoutes(PAGE_PATHS, location)?.[0].route?.path;
}
